// extracted by mini-css-extract-plugin
export default {"button":"Button_button__yQEx1","buttonOutline":"Button_buttonOutline__dYU3K","text":"Button_text__zuZ2z"};